// extracted by mini-css-extract-plugin
module.exports = {"divButton":"ButtonScrollSection_divButton__3Ip_g","buttonDown":"ButtonScrollSection_buttonDown__2bhDo","MoveUpDown":"ButtonScrollSection_MoveUpDown__GtwQt"};